import React, {Component} from 'react';
import {Field} from "redux-form";
import clsx from "clsx";

class LabeledToggleSelectionComponent extends Component {
    render() {
        const selectedOption = this.props.options.find(option => {
            return option.value === this.props.input.value;
        });
        return (
            <div className={clsx("labeled-toggle-selection", this.props.layout && ("labeled-toggle-selection--layout-" + this.props.layout))}>
                {this.props.options.map((option) => {
                    return (
                        <button type="button" key={`lbl_tgl_s_${option.value}`} onClick={(e) => {this.props.input.onChange(option.value)}} className={clsx("labeled-toggle-selection__button", selectedOption === option && "selected")}>
                            {option.label}
                        </button>
                    );
                })}
            </div>
        );
    }
}


function LabeledToggleSelection(props) {
    return <Field
        name={props.fieldId}
        forceValidation={props.forceValidation}
        component={LabeledToggleSelectionComponent}
        props={props}
    />
}

export default LabeledToggleSelection;



/** WEBPACK FOOTER **
 ** ./src/components/forms/LabeledToggleSelection.js
 **/